import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MessageSquare, Users, FileEdit, Clock, TrendingUp } from "lucide-react";
import { api } from "@/lib/api";

export default function AdminDashboard() {
  const [stats, setStats] = useState({ team: 0, approved: 0, pending: 0, total: 0 });

  useEffect(() => {
    (async () => {
      try {
        const [t, r] = await Promise.all([
          api.get("/team"),
          api.get("/reviews/admin"),
        ]);
        const items = r.data.items || [];
        setStats({
          team: t.data.length,
          approved: items.filter((x) => x.status === "approved").length,
          pending: items.filter((x) => x.status === "pending").length,
          total: items.length,
        });
      } catch {}
    })();
  }, []);

  const cards = [
    { label: "Сотрудников", value: stats.team, icon: Users, to: "/admin/team" },
    { label: "На рассмотрении", value: stats.pending, icon: Clock, to: "/admin/reviews", highlight: stats.pending > 0 },
    { label: "Одобренных отзывов", value: stats.approved, icon: MessageSquare, to: "/admin/reviews" },
    { label: "Всего отзывов", value: stats.total, icon: TrendingUp, to: "/admin/reviews" },
  ];

  return (
    <div className="max-w-6xl w-full">
      <div className="mb-8">
        <div className="text-xs font-semibold uppercase tracking-wider text-accent mb-2">Главная</div>
        <h1 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight" data-testid="dashboard-title">С возвращением</h1>
        <p className="text-sm text-muted-foreground mt-2">Управляйте контентом сайта, командой и отзывами в одном месте.</p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        {cards.map((c, i) => (
          <Link
            key={i}
            to={c.to}
            className={`group p-6 rounded-2xl border bg-card hover:border-foreground/30 transition-colors ${c.highlight ? "border-accent/50 glow-accent" : "border-border"}`}
            data-testid={`stat-card-${i}`}
          >
            <c.icon className="size-5 text-muted-foreground mb-4" />
            <div className="font-heading text-3xl font-bold">{c.value}</div>
            <div className="text-xs text-muted-foreground mt-1">{c.label}</div>
          </Link>
        ))}
      </div>

      <div className="grid md:grid-cols-3 gap-4">
        <Link to="/admin/content" className="p-6 rounded-2xl border border-border bg-card hover:border-foreground/30 transition-colors group" data-testid="quick-content">
          <FileEdit className="size-6 mb-3" />
          <h3 className="font-heading font-semibold mb-1">Редактировать сайт</h3>
          <p className="text-xs text-muted-foreground">Тексты, заголовки, кнопки, картинки и переводы.</p>
        </Link>
        <Link to="/admin/team" className="p-6 rounded-2xl border border-border bg-card hover:border-foreground/30 transition-colors group" data-testid="quick-team">
          <Users className="size-6 mb-3" />
          <h3 className="font-heading font-semibold mb-1">Управлять командой</h3>
          <p className="text-xs text-muted-foreground">Добавляйте сотрудников, меняйте фото и должности.</p>
        </Link>
        <Link to="/admin/reviews" className="p-6 rounded-2xl border border-border bg-card hover:border-foreground/30 transition-colors group" data-testid="quick-reviews">
          <MessageSquare className="size-6 mb-3" />
          <h3 className="font-heading font-semibold mb-1">Модерация отзывов</h3>
          <p className="text-xs text-muted-foreground">Одобряйте, отклоняйте, редактируйте или создавайте отзывы.</p>
        </Link>
      </div>
    </div>
  );
}
